import { logUserEvent } from 'fmc-digital-common';
import { amplifyLogs } from '../../../amplifyLogs';
export const getInitialFliterValue = tableList => {
  if (tableList.filter(function (e) {
    return e.taskStatus === 'To Do';
  }).length > 0) {
    return 'To Do';
  } else {
    return 'All Tasks';
  }
};
export const getFilteredList = (status, tableList) => {
  const unfilteredData = tableList;
  if (status === 'All Tasks') return unfilteredData;else {
    const filterStatus = status === 'All Tasks' ? 'Completed' : status;
    let data = tableList?.filter(item => {
      return item.taskStatus === filterStatus;
    });
    if (status === 'To Do') {
      data?.push(unfilteredData?.slice(-1)[0]);
    }
    return data;
  }
};
export const allFilters = [{
  label: 'To Do',
  value: 'To Do',
  id: '1'
}, {
  label: 'In Review',
  value: 'In Review',
  id: '2'
}, {
  label: 'Completed',
  value: 'Completed',
  id: '3'
}, {
  label: 'All Tasks',
  value: 'All Tasks',
  id: '4'
}];
export const setFilterValue = (value, tableData) => {
  switch (value) {
    case 'To Do':
      {
        logUserEvent(amplifyLogs.filterByToDoDropdown);
        return getFilteredList('To Do', tableData);
      }
    case 'In Review':
      {
        logUserEvent(amplifyLogs.filterByInReviewDropdown);
        return getFilteredList('In Review', tableData);
      }
    case 'Completed':
      {
        logUserEvent(amplifyLogs.filterByCompletedDropdown);
        return getFilteredList('Completed', tableData);
      }
    case 'All Tasks':
      {
        logUserEvent(amplifyLogs.filterByAllTasksDropdown);
        return tableData;
      }
    default:
      return tableData;
  }
};
export const getTaskCount = (filteredList, filtername) => {
  if (filtername === 'To Do' || filtername === 'All Tasks') {
    let count = filteredList?.length;
    return count - 1;
  } else {
    return filteredList?.length;
  }
};
export const dynamicFilterLabel = data => allFilters.map(obj => {
  if (obj.label === 'All Tasks') {
    return {
      label: `${obj.label} (${data.length - 1})`,
      value: obj.value,
      id: obj.id
    };
  } else {
    const obj123 = data.filter(function (e) {
      return e.taskStatus === obj.label;
    }).length;
    return {
      label: `${obj.label} (${obj123})`,
      value: obj.value,
      id: obj.id
    };
  }
});
export const isEnableInfoCard = status => {
  return status < 11 || status >= 13;
};
export const getInfoCardDetail = (text, state) => {
  let infoStatus = {
    title: '',
    description: '',
    subTitle: '',
    statusTrackerText: text,
    statusTrackerState: state
  };
  let combinationText = `${text}-${state}`;
  switch (combinationText) {
    case 'Processing-InProgress':
      infoStatus.title = 'Your loan is in processing';
      infoStatus.description = 'We are currently reviewing your financial information and other documentation to ensure all requested information has been provided before sending your loan to underwriting.';
      break;
    case 'Underwriting-InProgress':
      infoStatus.title = 'Your loan is in underwriting';
      infoStatus.description = 'During this stage, the financial information, credit history, and other risk factors on your loan application, along with all required supporting documentation, are being examined to determine if your loan will be approved. We will contact you if we need additional information.';
      break;
    case 'Closing-InProgress':
      infoStatus.title = 'Your loan is approved!';
      infoStatus.description = 'You will soon receive an email from Freedom Mortgage with instructions on how to schedule your closing appointment. Please schedule your closing to keep your loan moving forward.';
      break;
    case 'Done-InProgress':
      infoStatus.title = 'Your loan application is in final review.';
      infoStatus.description = 'At this stage, we are completing a final review of your loan application and supporting documentation to ensure nothing has changed between your loan approval and scheduled closing date.';
      break;
    case 'Done-Completed':
      infoStatus.title = 'Congratulations–your loan has closed!';
      infoStatus.subTitle = 'Thank you for choosing Freedom Mortgage for your financial needs.';
      infoStatus.description = 'We appreciate the trust you have placed in us.';
      break;
  }
  return infoStatus;
};
//# sourceMappingURL=index.js.map